module.exports = __webpack_public_path__ + "static/media/pdf_xls_csv.98c441e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdf_xls_csv.png
// module id = 13350
// module chunks = 0